module.exports = __webpack_public_path__ + "images/landing/video-previews/Wine_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Wine_2x.jpg
// module id = JBeu
// module chunks = 1